//import MicroModal from 'micromodal';
import { Util } from './_util.js';
import Lity from 'lity';

const Global = {
  wineDirectCart: function () {
    $('.show-cart-btn').on('click', function () {
      //console.log('open');
      vin65remote.cart.showCart();
    });

    // setTimeout(() => { $(".wines-grid .details").each(function() {
    //     $('.wines-grid .v65-widgetProduct-addToCart-button .add-to-cart span').text('Add');
    //     $(this).appendTo($(this).siblings().find('.v65-widgetProduct-addToCart-button')).addClass('wd-detail');
    //     $('section.pdp-info .v65-widgetProduct-addToCart-price').appendTo('.price-append');

    // })  }, 800);
  },
  lazyVideos: function () {
    document.addEventListener('DOMContentLoaded', function () {
      var videos = document.querySelectorAll('.video-lazy-load');

      videos.forEach(function (video) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            var source = video.querySelector('source');
            source.src = source.getAttribute('data-src');
            video.load();
            observer.disconnect();
          }
        });

        observer.observe(video);
      });
    });
  },
  wdAddToCartFormADA: function () {
    window.onload = function () {
      const updateButtonsContent = (buttons) => {
        buttons.forEach((button) => {
          const newContent = `
            <button type="submit" value="submit" class="defaultBtn add-to-cart label">
              <svg class="white-arrow" xmlns="http://www.w3.org/2000/svg" width="42" height="14" viewBox="0 0 42 14" fill="none">
                <path d="M41.63 6.99848C37.014 8.78794 34.9387 10.7709 33.2762 13.5309C32.3968 10.7274 33.7271 7.98923 34.5748 6.95154C32.663 4.648 32.8586 1.67078 33.2583 0.46875C35.696 4.556 39.8551 6.52493 41.63 6.99848Z" fill="#E5E3DD"></path>
                <path d="M30.9934 7.86792C30.9977 7.79838 31.3972 7.23046 31.5964 6.95519L30.9934 6.12939C30.9916 6.73788 30.989 7.93746 30.9934 7.86792Z" fill="#231F20" stroke="#231F20" stroke-width="0.139088"></path>
                <rect x="0.0834961" y="6.12939" width="30.907" height="1.74147" fill="#E5E3DD"></rect>
              </svg>
              ADD TO CART
              <svg class="black-arrow" xmlns="http://www.w3.org/2000/svg" width="43" height="14" viewBox="0 0 43 14" fill="none">
                <path d="M42.0638 6.75581C37.4479 8.54526 35.3725 10.5283 33.71 13.2882C32.8307 10.4847 34.161 7.74655 35.0086 6.70887C33.0969 4.40532 33.2925 1.4281 33.6922 0.226074C36.1298 4.31333 40.289 6.28225 42.0638 6.75581Z" fill="#231F20"/>
                <path d="M31.4272 7.62479C31.4316 7.55525 31.8311 6.98732 32.0303 6.71205L31.4272 5.88623C31.4254 6.49473 31.4229 7.69433 31.4272 7.62479Z" fill="#231F20" stroke="#231F20" stroke-width="0.139088"/>
                <rect x="0.517212" y="5.88623" width="30.907" height="1.74147" fill="#231F20"/>
              </svg>
            </button>
          `;
          button.innerHTML = newContent;
        });
      };

      const isWinePDP = $('.js-wineSingleAddToCart')[0];
      const buttons = document.querySelectorAll('.v65-widgetProduct-addToCart-button');

      if (isWinePDP) {
        const priceWrapperClone = $('.v65-widgetProduct-addToCart-priceWrapper').clone();
        priceWrapperClone.appendTo('.price');
        updateButtonsContent(buttons);
      } else if ($('.v65-widgetProduct-addToCart-button')[0]) {
        updateButtonsContent(buttons);
      }

      // Correct labels for form fields to ensure they are accessible to screen readers
      const formWrapper = document.querySelector('.v65-widgetFormWrapper');

      if (formWrapper) {
        // Array of IDs to create and descriptions to add
        const ariaReferences = [
          { id: 'InvalidFirstName', text: 'Please provide a valid first name.' },
          { id: 'InvalidLastName', text: 'Please provide a valid last name.' },
          { id: 'InvalidMainPhone', text: 'Please provide a valid phone number.' },
          { id: 'InvalidEmailFormat', text: 'Please provide a valid email address.' },
          { id: 'Question/Commentsisrequired', text: 'Please enter your questions or comments.' },
        ];

        // Iterate and create the missing elements
        ariaReferences.forEach(function (ref) {
          let descriptionElement = document.createElement('span');
          descriptionElement.id = ref.id;
          descriptionElement.className = 'sr-only'; // This makes it only available to screen readers
          descriptionElement.innerText = ref.text;
          descriptionElement.style.display = 'none'; // Hide the description visually
          document.body.appendChild(descriptionElement); // Append to body, or you can append to form
        });
      }
    };
  },

  wineSingleTitle: function () {
    if ($('.js-wineSingleTitle')[0]) {
      function wrapNumbersInSpan(element) {
        element.innerHTML = element.innerHTML.replace(/\d+/g, '<span class="numbers">$&</span>');
      }

      document.querySelectorAll('.js-wineSingleTitle').forEach(wrapNumbersInSpan);
    }
  },

  init: function () {
    this.wineDirectCart();
    //this.mediaVideoPlay();
    //this.wdAddToCartFormADA();

    //this.lazyVideos();
    //this.wineSingleTitle();
  },
};

export default Global;
